import { css } from "@emotion/react";
import tokens from "@kibela/design-tokens";

import { clearButtonDecoration } from "~/client/styles/emotion/mixins/clearButtonDecoration";
import { clearLinkDecoration } from "~/client/styles/emotion/mixins/clearLinkDecoration";

export const style = () => {
  return css({
    ...clearLinkDecoration(tokens.color.symbol.primary.default.value, tokens.color.symbol.primary.hover.value),
    ...clearButtonDecoration(),
    position: "relative",
    borderRadius: "50%",
  });
};
